import { z } from 'zod'
import { PeriodUnitType, type ConsumptionSheetExpirationERPSettings } from '../../models/ConsumptionSheetERPSettings'

export const ConsumptionSheetExpirationERPSettingsDTO = z.object({
  amount: z.number().nullish(),
  period_unit: z.nativeEnum(PeriodUnitType).nullish()
})

export type ConsumptionSheetExpirationERPSettingsDTO = z.infer<typeof ConsumptionSheetExpirationERPSettingsDTO>

export function mapConsumptionSheetExpirationERPSettingsToDTO (model: ConsumptionSheetExpirationERPSettings): ConsumptionSheetExpirationERPSettingsDTO {
  return {
    amount: model.amount,
    period_unit: model.periodUnit
  }
}

export function mapDTOToConsumptionSheetExpirationERPSettings (dto: ConsumptionSheetExpirationERPSettingsDTO): ConsumptionSheetExpirationERPSettings {
  return {
    amount: dto.amount ?? undefined,
    periodUnit: dto.period_unit ?? undefined
  }
}
